import { useLoadingContext } from '../contexts/LoadingContext';

export const useLoading = (key?: string) => {
  const context = useLoadingContext();
  
  // Métodos genéricos para loading global
  const setGlobalLoading = (loading: boolean) => {
    context.setLoadingState('global-loading', loading);
  };

  const setPageLoading = (loading: boolean) => {
    context.setLoadingState('page-loading', loading);
  };

  const setAuthLoading = (loading: boolean) => {
    context.setLoadingState('auth-loading', loading);
  };

  const setAppLoading = (loading: boolean) => {
    context.setLoadingState('app-loading', loading);
  };

  const withGlobalLoading = async <T>(operation: () => Promise<T>): Promise<T> => {
    return context.withLoading('global-loading', operation);
  };

  const withPageLoading = async <T>(operation: () => Promise<T>): Promise<T> => {
    return context.withLoading('page-loading', operation);
  };

  const withAuthLoading = async <T>(operation: () => Promise<T>): Promise<T> => {
    return context.withLoading('auth-loading', operation);
  };

  const result = {
    ...context,
    setGlobalLoading,
    setPageLoading,
    setAuthLoading,
    setAppLoading,
    withGlobalLoading,
    withPageLoading,
    withAuthLoading,
  };

  if (key) {
    // Adiciona handler específico para uma chave
    const keyHandler = context.createLoadingHandler(key);
    return {
      ...result,
      ...keyHandler,
    };
  }

  return result;
};
